import { createContext } from 'react';
import type { AuthState } from './auth-provider.state';

interface AuthContextType extends AuthState {
  /**
   * Handler that is called when the user logs in.
   * This is only called if the user is not already authenticated (isAuthenticated is false).
   */
  onAuthenticate: (
    email: string,
    password: string,
    onSuccess?: (data: AuthState) => void | Promise<void>,
    onError?: (error: unknown) => void,
  ) => Promise<void>;
  /**
   * Handler that is called when the user reauthenticates.
   * This is only called if the user is already authenticated (isAuthenticated is true).
   */
  onReauthenticate: () => Promise<boolean>;
  /**
   * Handler that is called when the user logs out. This will remove all auth state.
   */
  onRemoveAuthentication: () => Promise<void>;
  /**
   * Handler that is called when the user resets their password.
   */
  onSetPassword: (
    user_id: string,
    token: string,
    new_password: string,
    onSuccess?: (data: AuthState) => void | Promise<void>,
    onError?: (error: unknown) => void,
  ) => Promise<void>;
  /**
   * Handler that is called when the user exchanges a token for an organization.
   */
  onExchangeToken: (organizationId: string, organizationName: string, portfolioId: string) => Promise<void>;
  /**
   * Handler that is called when the user dismisses the banner.
   */
  onDismissBanner: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export type { AuthContextType };
export { AuthContext };
